import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CustomizedApplicationPayload } from '@ca/core/models';
import { UserService } from '@ca/core/services';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FullNamePipe } from '../../../../shared/pipes/full-name/full-name.pipe';
import { FilesUploadButtonComponent } from '../../../../shared/components/files-upload-button/files-upload-button.component';

@Component({
    selector: 'ca-request-application-dialog',
    templateUrl: './request-application-dialog.component.html',
    styleUrls: ['./request-application-dialog.component.scss'],
})
export class RequestApplicationDialogComponent implements OnInit {
    @ViewChild(FilesUploadButtonComponent) uploadComponent: FilesUploadButtonComponent;
    @Output() onSubmit = new EventEmitter<CustomizedApplicationPayload>();
    formGroup: UntypedFormGroup;

    constructor(
        private activeModal: NgbActiveModal,
        private formBuilder: UntypedFormBuilder,
        private userService: UserService,
        private fullNamePipe: FullNamePipe,
    ) {}

    ngOnInit(): void {
        const email: string | undefined = this.userService.myInfo?.email;
        this.formGroup = this.formBuilder.group({
            email: [email, [Validators.required, Validators.email]],
            description: ['', [Validators.required]],
        });
    }

    buildPayload(): CustomizedApplicationPayload {
        return {
            userFullName: this.fullNamePipe.transform(this.userService.myInfo),
            email: this.formGroup.get('email')?.value,
            description: this.formGroup.get('description')?.value,
            imageUrls: this.uploadComponent.fileUrls.value,
        };
    }

    dismiss(): void {
        this.activeModal.close();
    }
    submit() {
        const payload: CustomizedApplicationPayload = this.buildPayload();
        this.onSubmit.next(payload);
    }
}
